import { useState, useEffect, useCallback } from 'react';
import axios from "./apiClient";
import {
  domain as HR7_DOMAIN,
  token,
  HR7_SUBSCRIPTION_DOMAIN,
  HR7_SERVICE_ID,
  getClientLicenseKey
} from '../components/Security';


export const fetchAvailableSlot = async () => {
  const domain = HR7_SUBSCRIPTION_DOMAIN;
  const clientLicenseKey = getClientLicenseKey() ?? null; // change this from local
  const apiUrl = domain + '/api/getAllUsersFromClient';

  const response = await axios.get(apiUrl, {
    params: {
      serviceId: HR7_SERVICE_ID,
      clientLicenseKey: clientLicenseKey,
      hasSubscribed: true,
      isTaken: false,
    }
  });


  // validate the response
  if (response.data) {
    const users = response.data?.users ?? [];

    // Sort alphabetically by lowerCaseName
    users.sort((a, b) =>
      (a.lowerCaseName || '').localeCompare(
        b.lowerCaseName || '',
        undefined,
        {
          numeric: true,
          sensitivity: 'base',
        }
      )
    );

    return users;
  }
  return null;
};

export const fetchAllSlot = async () => {
  const domain = HR7_SUBSCRIPTION_DOMAIN;
  const clientLicenseKey = getClientLicenseKey() ?? null; // change this from local
  const apiUrl = domain + '/api/getAllUsersFromClient';

  const response = await axios.get(apiUrl, {
    params: {
      serviceId: HR7_SERVICE_ID,
      clientLicenseKey: clientLicenseKey,
      hasSubscribed: true,
    }
  });

  // validate the response
  if (response.data)
    return response.data?.users ?? null;
  return null;
}

export const fetchLicenseDetails = async (license) => {
  const domain = HR7_SUBSCRIPTION_DOMAIN;
  const clientLicenseKey = getClientLicenseKey() ?? null;
  const apiUrl = domain + '/api/userLicenseDetails';

  try {
    const response = await axios.get(apiUrl, {
      params: {
        serviceId: HR7_SERVICE_ID,
        clientLicenseKey,
        licenseKey: license,
      }
    });

    // ✅ return what the API says
    return response.data ?? null;

  } catch (error) {
    console.error('License check failed', error);
    throw error; // let caller decide what to do
  }
};

export const fetchUserStatus = async (employeeId) => {
  const domain = HR7_SUBSCRIPTION_DOMAIN;
  const clientLicenseKey = getClientLicenseKey() ?? null;
  const apiUrl = domain + '/api/userStatus';

  try {
    const response = await axios.get(apiUrl, {
      params: {
        serviceId: HR7_SERVICE_ID,
        clientLicenseKey,
        systemUserId: employeeId,
      }
    });

    // ✅ return what the API says
    return response.data ?? null;

  } catch (error) {
    console.error('User License check failed', error);
    throw error; // let caller decide what to do
  }
}

export const insertUserSubscription = async (license, employeeId) => {
  const domain = HR7_SUBSCRIPTION_DOMAIN;
  const clientLicenseKey = getClientLicenseKey() ?? null;
  const apiUrl = domain + '/api/createSystemUserId';

  try {
    await axios.put(apiUrl, null, {
      params: {
        serviceId: HR7_SERVICE_ID,
        clientLicenseKey,
        systemUserId: employeeId,
        userLicenseKey: license
      }
    });
  } catch (error) {
    // Re-throw axios error as-is
    throw error;
  }
};


export const updateUserSubscription = async (license, employeeId) => {
  const domain = HR7_SUBSCRIPTION_DOMAIN;
  const clientLicenseKey = getClientLicenseKey() ?? null;
  const apiUrl = domain + '/api/createSystemUserId';

  await axios.put(apiUrl, null, {
    params: {
      serviceId: HR7_SERVICE_ID,
      clientLicenseKey: clientLicenseKey,
      systemUserId: employeeId,
      userLicenseKey: license
    }
  });
}

export const removeUserSubscriptionold = async (employeeId) => {
  const domain = HR7_SUBSCRIPTION_DOMAIN;
  const clientLicenseKey = getClientLicenseKey() ?? null;
  const apiUrl = domain + '/api/updateUserIsTakenStatus';

  try {
    await axios.put(apiUrl, null, {
      params: {
        serviceId: HR7_SERVICE_ID,
        clientLicenseKey: clientLicenseKey,
        systemUserId: employeeId,
        isTaken: false
      }
    });
  } catch (error) {
    console.error(error);
  }
}

export const removeUserSubscription = async (license) => {
  const domain = HR7_SUBSCRIPTION_DOMAIN;
  const clientLicenseKey = getClientLicenseKey() ?? null;
  const apiUrl = domain + '/api/removeSystemUserId';

  try {
    const response = await axios.put(apiUrl, null, {
      params: {
        serviceId: HR7_SERVICE_ID,
        clientLicenseKey: clientLicenseKey,
        userLicenseKey: license,
      }
    });

    console.log(response)
  } catch (error) {
    console.error(error);
  }
}

export const checkLicenseIfTaken = async (license, employeeId) => {
  try {

    const licenseDetails = await fetchLicenseDetails(license);

    if (licenseDetails?.isTaken === true && licenseDetails?.systemUserId !== employeeId) return true;
    else return false
  } catch (error) {
    console.error("License check: ", error);
    throw error;
  }
}

export const checkUserLicenseIfActive = async (employeeId, license) => {
  try {
    const userLicenseDetails = await fetchUserStatus(employeeId);

    if (userLicenseDetails?.user.isTaken === true
      && userLicenseDetails?.user.licenseKey === license
      && userLicenseDetails?.user.hasSubscribed === true
      && userLicenseDetails?.client.hasSubscribed === true
      && userLicenseDetails?.systemUserId !== employeeId
    ) {
      return true;
    }
    return false
  } catch (error) {
    throw error;
  }
}

export const fetchIsUnlimitedAccount = async () => {
  try {
    const apiUrl = HR7_DOMAIN + "/api/Subscription/"
    const response = await axios.get(apiUrl + `get-isunlimited-acc`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })

    if (response.data)
      return response.data;
    return null;

  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

export const fetchIsUnlimitedAccountByName = async (clientName) => {
  try {
    const apiUrl = HR7_DOMAIN + "/api/Subscription/"
    const response = await axios.get(apiUrl + `get-isunlimited-acc/${clientName}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })

    if (response.data)
      return response.data;
    return null;

  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

export const checkUnlimitedAccount = async (clientName) => {
  const result = await fetchIsUnlimitedAccount(clientName);

  return result?.isUnlimitedAccount ? result.isUnlimitedAccount : false;
}